import React from 'react';
import { Box, Typography } from '@mui/material';

const Field: React.FC<{ label: string; value?: string }> = ({ label, value }) => (
  <Box sx={{ mb: 1.5 }}>
    <Typography variant="caption" color="text.secondary">{label}</Typography>
    <Typography variant="body1">{value || '—'}</Typography>
  </Box>
);

export default Field;
